@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    <span
      >{{ getStatusByType($.row[$.adata.fetch_key], $.adata.status_type) }}
    </span>
  }
}
